import React from "react";
import ItemAvatar from "../../../components/ItemAvatar";
import { formatIDR } from "../../../utils/helpers/formatIDR";

const TopSellingProducts = ({ products = [], loading = false, onSelect }) => {
  const rankedProducts = products.slice(0, 5);

  return (
    <aside className="card dashboard-card dashboard-top-products-card h-100">
      <div className="card-header">
        <h3 className="card-title mb-0">Produk terlaris</h3>
        <span className="badge bg-primary-lt text-primary">Top 5</span>
      </div>
      <div className="card-body dashboard-product-feed">
        {loading ? (
          [...Array(5)].map((_, index) => <div className="dashboard-product-skeleton placeholder" key={index} />)
        ) : rankedProducts.length ? (
          rankedProducts.map((product, index) => (
            <button
              type="button"
              className="dashboard-product-row"
              key={`${product?.id || product?.name}-${index}`}
              onClick={() => onSelect?.(product)}
              aria-label={`Lihat detail ${product?.name || "produk"}`}>
              <span className="dashboard-product-rank">{index + 1}</span>
              <ItemAvatar
                name={product?.name || "Produk"}
                image={product?.image_path || product?.image}
                size="md"
              />
              <span className="dashboard-product-info">
                <strong>{product?.name || "Produk"}</strong>
                <small>{Number(product?.total_qty || 0).toLocaleString("id-ID")} terjual</small>
              </span>
              <span className="dashboard-product-value">
                <strong>{formatIDR(product?.total_sales || 0)}</strong>
                <small>Total Penjualan</small>
              </span>
            </button>
          ))
        ) : (
          <div className="dashboard-product-empty">
            <span aria-hidden="true">◇</span>
            <p>Belum ada produk terjual pada periode ini.</p>
          </div>
        )}
      </div>
    </aside>
  );
};

export default TopSellingProducts;
